
import { useEffect } from 'react';
import { useRobustWebsiteSettings } from '@/hooks/useRobustWebsiteSettings';

export const DynamicManifest = () => {
  const { settings } = useRobustWebsiteSettings();

  useEffect(() => {
    if (settings) {
      const manifest = {
        name: settings.site_name || 'TerraGamers - Free Online Games',
        short_name: settings.site_name?.split(' ')[0] || 'TerraGamers',
        description: settings.site_description || 'Play thousands of free online games instantly',
        start_url: '/',
        display: 'standalone',
        background_color: '#ffffff',
        theme_color: '#3B82F6',
        orientation: 'portrait-primary',
        categories: ['games', 'entertainment'],
        lang: 'en',
        scope: '/',
        icons: [
          {
            src: settings.favicon_url || '/icon-192.png',
            sizes: '192x192',
            type: 'image/png',
            purpose: 'any maskable'
          },
          {
            src: settings.favicon_url || '/icon-512.png',
            sizes: '512x512',
            type: 'image/png',
            purpose: 'any maskable'
          }
        ],
        shortcuts: [
          {
            name: 'Trending Games',
            short_name: 'Trending',
            description: 'View trending games',
            url: '/trending',
            icons: [{ src: settings.favicon_url || '/icon-192.png', sizes: '192x192' }]
          },
          {
            name: 'New Games',
            short_name: 'New',
            description: 'View new games',
            url: '/new',
            icons: [{ src: settings.favicon_url || '/icon-192.png', sizes: '192x192' }]
          }
        ]
      };

      // Update existing manifest link or create new one
      let manifestLink = document.querySelector('link[rel="manifest"]') as HTMLLinkElement;
      if (!manifestLink) {
        manifestLink = document.createElement('link');
        manifestLink.rel = 'manifest';
        document.head.appendChild(manifestLink);
      }

      // Create blob URL for the manifest
      const manifestBlob = new Blob([JSON.stringify(manifest, null, 2)], {
        type: 'application/json'
      });
      const manifestUrl = URL.createObjectURL(manifestBlob);
      manifestLink.href = manifestUrl;

      return () => {
        URL.revokeObjectURL(manifestUrl);
      };
    }
  }, [settings]);

  return null;
};
